// HeroSection.jsx

import React, { useEffect } from "react";
import "../Styles/about.css";
import { useNavigate } from "react-router-dom";





// ── Checkmark Button Icon ────────────────────────────────────────────────────
function CheckIcon() {
  return (
    <img
      className="about__btn-icon"
      src="/assets/ing.png"
      alt="check icon"
    />
  );
}

// ── Hero Section ─────────────────────────────────────────────────────────────
export default function HeroSection() {
   const navigate = useNavigate();  // 
     useEffect(() => {
    document.title = "What We Do | Outstanding Workplaces";
  }, []);
  return (
    <>
      {/* ── SECTION 1: Hero ── */}
      <section className="about" aria-label="Welcome section">

        {/* ── LEFT: Text content ── */}
        <div className="about__left">

          <h1 className="about__title">
            Welcome to<br />Outstanding Workplaces
          </h1>

          <div className="about__body">
            <p className="about__para">
              At <strong>Outstanding Workplaces</strong>, we believe that culture is the foundation 
              of organizational success. Our workplace culture certification program is designed to
               help companies foster employee well-being, enhance engagement, and drive business
                results. We recognize and celebrate organizations that prioritize their people, 
                creating a positive and productive work environment that benefits everyone.
            </p>

            <p className="about__para">
           Evaluate workplace cultures based on key factors like employee engagement, 
           development opportunities, and company values. Certify organizations that
            demonstrate a commitment to creating an outstanding workplace. Provide insights
             and best practices to help companies improve their workplace cultures.
            </p>

            <p className="about__para">
            Exceptional workplace cultures drive business success, innovation, and 
            employee satisfaction. Companies with positive workplaces attract and retain 
            top talent, improving productivity and retention. Outstanding Workplaces certification 
            is a mark of excellence, setting companies apart in a competitive market.
            </p>
          </div>

         <button 
  className="about__btn" 
  type="button"
  onClick={() => {
    navigate('/nominate');
    window.scrollTo(0, 0);   // 👈 scroll to top
  }}
>
  <CheckIcon />
  Get Certificate
</button>

        </div>

        {/* ── RIGHT: Image ── */}
  <div className="about__right">
   <img
  className="about__img-group"
  src="/assets/Group.png"
  alt="Workplace professionals"
/>
  </div>

      </section>

      {/* ── SECTION 2: Our Values ── */}
      <section className="values">

        <div className="values__header">
          <h2 className="values__title">Our Values</h2>
          <p className="values__subtitle">Empowering People. Shaping Culture. Driving Growth.</p>
        </div>

        <div className="values__cards">

          <div className="values__card">
            <div className="values__icon-box">
           <img src="/assets/People.png" className="values__icon" />
        </div>

            <h3 className="values__card-title">Empowering People</h3>
            <p className="values__card-desc">
              We believe people are the driving force behind every successful organization.
               By fostering trust, ownership, and accountability, we empower individuals to
                unlock their full potential and contribute meaningfully to business growth.
            </p>
          </div>

          <div className="values__card">
          <div className="values__icon-box">
         <img src="/assets/New_Company.png" className="values__icon" />
          </div>

            <h3 className="values__card-title">Transforming Workplace Culture</h3>
            <p className="values__card-desc">
             A positive and inclusive workplace culture fuels innovation and engagement. 
             We are committed to building environments where collaboration thrives, ideas 
             are valued, and every voice is heard.
            </p>
          </div>

          <div className="values__card">
        <div className="values__icon-box">
        <img src="/assets/Positive_Dynamic.png" className="values__icon" />
        </div>

            <h3 className="values__card-title">Innovation & Continuous Growth</h3>
            <p className="values__card-desc">
              We embrace change as an opportunity to grow. Through continuous learning, 
              forward-thinking strategies, and innovative practices, we help organizations 
              stay ahead in an ever-evolving world.
            </p>
          </div>

        </div>
      </section>


{/* ── SECTION 3: Building Inspiring Workplaces ── */}
<section className="inspire">

  <div className="inspire__top">
    <h2 className="inspire__title">Building Inspiring Workplaces</h2>
    <p className="inspire__desc">
      Outstanding Workplaces is a content-driven platform dedicated to elevating employer branding.
       We partner with organizations to create environments where employees feel valued, motivated, 
       and deeply connected to their workplace.
    </p>
  </div>

  <div className="inspire__bottom">
    <h3 className="inspire__sub-title">A Framework For Better Workplaces</h3>

    <div className="inspire__cards">

      <div className="inspire__card">
 <img src="/assets/Web_Analytics.png" className="inspire__icon" />
  <p className="inspire__card-label">Measure</p>
</div>

<div className="inspire__card">
 <img src="/assets/Upgrade.png" className="inspire__icon" />
  <p className="inspire__card-label">Enhance</p>
</div>

<div className="inspire__card">
  <img src="/assets/Find_User_Male.png" className="inspire__icon" />
  <p className="inspire__card-label">Recognize</p>
</div>

    </div>
  </div>

</section>



{/* ── SECTION 4: Transforming Workplaces ── */}
<section className="vision">

  <div className="vision__header">
    <h2 className="vision__title">Transforming Workplaces, Empowering People</h2>
    <p className="vision__subtitle">
      Our vision and mission are to transform every workplace into an outstanding environment where everyone can thrive.
    </p>
  </div>

  <div className="vision__cards">

   <div className="vision__card">
  <div className="vision__icon-box">
    <img src="/assets/Idea.png" className="vision__icon" />
  </div>

      <h3 className="vision__card-title">Our Vision</h3>
      <p className="vision__card-desc">
       A world where every workplace is a positive, productive, and fulfilling environment 
       that brings out the best in employees and drives business results.
      </p>
    </div>

    <div className="vision__card">
  <div className="vision__icon-box">
   <img src="/assets/Rocket.png" className="vision__icon" />
  </div>

      <h3 className="vision__card-title">Our Mission</h3>
      <p className="vision__card-desc">
        To empower organizations to create exceptional workplace cultures that foster
        employee well-being, engagement, and success.
      </p>
    </div>

  </div>

</section>

    </>
  );
}